import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Table, Form, Button, Container, Row, Col } from 'react-bootstrap';
import { API_MASTER_URL } from '../../config/config';
import routes from './../../routes/routes';

const LogViewer = () => {
    const [clientId, setClientId] = useState('');
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [logs, setLogs] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate(routes.LOGIN);
        } else {
            fetchLogs();
        }
    }, [navigate]);

    const fetchLogs = async (client_id = '', start_date = '', end_date = '') => {
        try {

            const response = await axios.post(`${API_MASTER_URL}/get-master-suppression-logs`, {
                client_id,
                start_date,
                end_date
            });
            setLogs(response.data.logs);
            setError('');
        } catch (err) {
            setLogs([]);
            setError('Failed to fetch logs. Please check your inputs.');
            console.error(err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        fetchLogs(clientId, start_date, end_date);
    };

    return (
        <Container>
            <Row className="justify-content-md-center mt-5">
                <Col md={8}>
                    {error && <p className="text-danger">{error}</p>}
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={3}>
                                <Form.Group controlId="formClientId">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Client ID"
                                        value={clientId}
                                        onChange={(e) => setClientId(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="formStartDate">
                                    <Form.Control
                                        type="date"
                                        placeholder="Enter Start Date"
                                        value={start_date}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="formEndDate">
                                    <Form.Control
                                        type="date"
                                        placeholder="Enter End Date"
                                        value={end_date}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Button variant="primary" type="submit" >
                                    Get Logs
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            {logs.length > 0 && (
                <Row className="mt-4">
                    <Col>
                        <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Date</th>
                                <th>Client Id</th>
                                <th>List Id</th>
                                <th>Segment Ids</th>
                                <th>Suppression Id</th>
                                <th>Status</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{log.createdDate}</td>
                                <td>{log.clientId}</td>
                                <td>{log.listId}</td>
                                <td>{log.segmentIds.join(', ')}</td>
                                <td>{log.masterSuppressionListId}</td>
                                <td>{log.status}</td>
                                <td>{log.listStatus} <br /> File Name : {log.fileName}</td>
                            </tr>
                            ))}
                        </tbody>
                        </Table>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default LogViewer;
